import {AvailabilityApiResponseChannel} from '../../server/routes/availability/types';

export function formatNumber(
  numberValue: number,
  decimals = 0,
  channelData: AvailabilityApiResponseChannel,
): string {
  const separator = channelData.decimalSeparator || '.';
  const roundedNumber = numberValue.toFixed(decimals);
  const formattedNumber = roundedNumber.replace('.', separator);

  return `${formattedNumber}`;
}

export function formatDistance(
  distance: number,
  channelData: AvailabilityApiResponseChannel,
): string {
  if (distance < 0.1) {
    return formatNumber(0.1, 1, channelData);
  }
  if (distance < 5) {
    return formatNumber(distance, 1, channelData);
  }
  return formatNumber(Math.round(distance), 0, channelData);
}

export const formatDistanceUnit = (
  distanceUnit: AvailabilityApiResponseChannel['distanceUnit'],
) => {
  switch (distanceUnit) {
    case 'mile': {
      return 'mi';
    }
    case 'kilometre': {
      return 'km';
    }
    default: {
      return distanceUnit;
    }
  }
};
